import React from 'react';

export const CorporateServicesSection = ({ t, services, onServiceAction }) => {
  return (
    <section id="services" className="py-12 sm:py-20 bg-white" data-testid="home-services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" data-testid="home-services-title">
            {t('services.title')}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600" data-testid="home-services-subtitle">{t('services.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-testid="home-services-grid">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
              onClick={() => onServiceAction(service)}
              data-testid={`home-service-card-${service.id}`}
            >
              <div className="relative h-48 sm:h-56 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
                <div className="text-6xl sm:text-7xl" data-testid={`home-service-card-icon-${service.id}`}>{service.icon}</div>
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold" data-testid={`home-service-card-count-${service.id}`}>
                  {service.subCategories.length} {service.subCategories.length > 1 ? t('services.options') : t('services.option')}
                </div>
              </div>

              <div className="p-5 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3" data-testid={`home-service-card-title-${service.id}`}>{service.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4" data-testid={`home-service-card-description-${service.id}`}>{service.description}</p>
                <button className="text-blue-600 font-semibold hover:text-blue-700 transition inline-flex items-center" data-testid={`home-service-card-action-${service.id}`}>
                  {service.externalLink ? 'Ir para o formulário' : t('services.viewDetails')}
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
